export default __webpack_public_path__ + "static/media/dark-blue-ball-inverted.d7f20ef1.svg";